const INFO = {
	main: {
		title: "Hamdan PortFolio",
		name: "Hamdan ",
		email: "xhamdanisrar@gmail.com",
		logo: "../logo.png",
	},

	socials: { 
		github: "https://github.com/HadiDevLabx",
		linkedin: "https://www.linkedin.com/in/xhamdanisrar/",  
	},

	homepage: {
		"title": "Full-Stack Developer\n& Backend Specialist",
		"description": "**Full-Stack Developer** with **4+ years experience** in React.js, Angular, Node.js, PHP, Java, Laravel, Python, and mobile development (Flutter, Android, React Native). Specialized in **CRM development**, **AI integrations**, **.NET APIs**, **WhatsApp & third-party API automation** (n8n, Zapier), and **AWS** cloud infrastructure. Skilled in **MySQL/MongoDB/PostgreSQL**, responsive UI, Shopify, Web3, and building **scalable, tested, and reliable solutions**."
	},
	about: {
		"title": "I'm Hamdan. I live in UAE, where I design the future.",
		"description": "Over the years, I've poured my passion and creativity into a diverse array of projects, each one a step forward in my journey as a developer. I'm incredibly proud of the progress I've made and the skills I've honed. Many of my projects are open-source, reflecting my belief in the power of community and collaboration. I invite you to explore my work, dive into the code, and share your thoughts or enhancements. I'm always eager to learn from others and grow together. Let's push the boundaries of what's possible and innovate for a brighter future."
	},
	

	projects: [
		{
			"title": "Dubimark – Grocery E-commerce Ecosystem",
			"description": "Independently completed and accelerated development of a large-scale grocery e-commerce ecosystem with 3 Flutter apps (User, Vendor, Delivery). Redesigned UI/UX with advanced features including reward system, replacement item logic, multi-location delivery, and UAE-specific compliance. Integrated Careem APIs for third-party rider delivery, fully connected with admin panel and user workflows. Built Laravel admin panel with advanced order management, delivery controls, and vendor tools. Built and maintained React & Next.js web platform aligned with mobile apps, deployed on VPS with production-ready configurations. Developed and optimized MongoDB collections for improved data retrieval performance and scalability. Built reusable React components using Tailwind CSS, shadcn/ui, and Material UI.",
			"logo": ["../flutter.png", "../react1.png", "../nextjs.png", "../mern.png"],
			"linkText": "Visit Website",
			"link": "https://dubimark.com",
			"linkAndroid": "https://play.google.com/store/apps/details?id=dubimark.app.ae",
			"linkIOS": "https://apps.apple.com/us/app/dubimark/id6479883471",
			"image": "../iphone-dubimark.png",
			"imageAndroid": "../android-dubimark.png",
			"category": "Mobile",
			"tags": ["Flutter", "Laravel", "React", "Next.js", "MongoDB", "Careem API", "TailwindCSS", "VPS", "UAE"]
		},
		{
			"title": "Liali Events – Portfolio Website",
			"description": "Independently developed and deployed Liali Events Org portfolio website using Laravel for frontend, backend, and admin panel. Full production deployment on AWS EC2 with server setup, domain configuration, and secured environment management.",
			"logo": ["../react1.png", "../mern.png"],
			"linkText": "Visit Website",
			"link": "https://lialieventsorg.com",
			"image": "../lialieventsorg.png",
			"category": "Web",
			"tags": ["Laravel", "PHP", "AWS EC2", "Admin Panel"]
		},
		{
			"title": "HotelsVenues – Venue Search Platform",
			"description": "Built HotelsVenues, a full-featured venue search and booking system with user and admin panels, complete frontend-backend implementation. Users can search, filter, and enquire about venues while admins manage listings, bookings, and content.",
			"logo": ["../react1.png", "../mern.png"],
			"linkText": "Visit Website",
			"link": "https://hotelvenues.com",
			"image": "../hotelvenues.jpeg",
			"category": "Web",
			"tags": ["Laravel", "PHP", "MySQL", "Admin Panel", "AWS EC2"]
		},
		{
			"title": "Liali CRM – WhatsApp & Automation",
			"description": "Designed and developed a custom CRM system with role-based access control, timeline and activity management, WhatsApp API integration for automated messaging, and workflow automation using n8n and Zapier. Deployed on AWS EC2 with full production configuration.",
			"logo": ["../react1.png", "../mern.png"],
			"linkText": "View CRM Dashboard",
			"link": "https://drive.google.com/file/d/1VZi65TE7Wla_QpTiADbfuc4efAWtNcWM/view",
			"image": "../liali-crm.png",
			"category": "Web",
			"tags": ["React", "Node.js", "WhatsApp API", "n8n", "Zapier", "RBAC", "AWS EC2"]
		},
		{
			"title": "Liali Sales – React Native Field App",
			"description": "Created a React Native sales application with check-in/check-out, live location tracking, venue visit forms, photo uploads, offline data sync, route history tracking, and push notifications. Includes an admin monitoring panel for real-time field activity tracking.",
			"logo": ["../reactnative.png", "../mern.png"],
			"linkText": "View App",
			"link": "https://drive.google.com/file/d/1VZi65TE7Wla_QpTiADbfuc4efAWtNcWM/view",
			"image": "../sales-app-liali.jpeg",
			"category": "Mobile",
			"tags": ["React Native", "Node.js", "GPS Tracking", "Offline Sync", "Push Notifications"]
		},
		{
			"title": "VM Properties – Real Estate Website",
			"description": "Developed vm-properties.com, a high-performance real estate website built with Next.js and GSAP animations, delivering a modern and responsive property browsing experience. Agent profiles, property listings, and lead capture forms sync in real time with the CRM backend.",
			"logo": ["../nextjs.png", "../mern.png"],
			"linkText": "Visit Website",
			"link": "https://vm-properties.com/",
			"image": "../Vmproperties.png",
			"category": "Web",
			"tags": ["Next.js", "GSAP", "Node.js", "MongoDB", "UAE"]
		},
		{
			"title": "VM Properties – CRM Dashboard",
			"description": "Built a full-featured CRM tightly integrated with the VM Properties website. Features agent listings management, internal team chat, leads pipeline, deals tracking, and role-based access control. Agent profiles, property listings, and lead capture forms sync in real time between the public site and CRM backend.",
			"logo": ["../react1.png", "../mern.png"],
			"linkText": "View CRM Dashboard",
			"link": "https://drive.google.com/file/d/1VZi65TE7Wla_QpTiADbfuc4efAWtNcWM/view",
			"image": "../vm properties crm.png",
			"category": "Web",
			"tags": ["React", "Node.js", "CRM", "RBAC", "MongoDB", "Real-time"]
		},
		{
			"title": "Ugmonk – Shopify Store",
			"description": "Developed and customized Shopify store for Ugmonk, a premium analog tools brand. Implemented custom theme modifications, product page enhancements, and conversion-optimized checkout flow.",
			"logo": "../shopify.png",
			"linkText": "Visit Store",
			"link": "https://ugmonk.com/",
			"image": "../ugmonk.png",
			"category": "Shopify",
			"tags": ["Shopify", "Liquid", "JavaScript", "CSS"]
		},
		{
			"title": "Angel Crafty Kreations",
			"description": "Built and managed Shopify store for handmade crafts brand. Integrated secure payment methods, custom product variants, automated email flows, and optimized for mobile shopping experience.",
			"logo": "../shopify.png",
			"linkText": "Visit Store",
			"link": "https://angelcraftykreations.com/",
			"image": "../angel_crafty_kreations.png",
			"category": "Shopify",
			"tags": ["Shopify", "Liquid", "Payments"]
		},
		{
			"title": "Pawfect Pet Picks",
			"description": "Created and managed Shopify store for pet products brand. Custom theme, product collections, upsell integrations, and SEO optimization to drive organic traffic.",
			"logo": "../shopify.png",
			"linkText": "Visit Store",
			"link": "https://pawfectpicks.pet/",
			"image": "../pawfect_pet_picks.png",
			"category": "Shopify",
			"tags": ["Shopify", "Liquid", "SEO"]
		},
		{
			"title": "E-commerce Platform",
			"description": "Full-featured e-commerce platform with user authentication, product management, shopping cart, order processing, and Stripe payment integration. Responsive design with advanced search and filtering for optimal product discovery.",
			"logo": ["../nextjs.png", "../mern.png"],
			"linkText": "Live Demo",
			"link": "https://dev-shop-ruby.vercel.app/",
			"image": "../ecommerce.png",
			"category": "Web",
			"tags": ["Next.js", "Laravel", "MySQL", "Stripe"]
		},
		{
			"title": "AI Image Generator",
			"description": "Free AI-powered image generation platform built with Next.js 15 and FLUX.1 model. Users can generate high-quality images from text prompts with real-time preview and download support.",
			"logo": "../nextjs.png",
			"linkText": "Live Demo",
			"link": "https://ai-image-generator-tau-tan.vercel.app/",
			"image": "../ai-image-project.png",
			"category": "AI",
			"tags": ["Next.js", "FLUX.1", "AI", "Vercel"]
		},
		{
			"title": "Hadi CRM Sales",
			"description": "Next-generation CRM platform with sales pipeline management, customer tracking, analytics dashboard, and team collaboration tools. Built for UAE-based sales teams with multi-role access control.",
			"logo": ["../react1.png", "../mern.png"],
			"linkText": "Live Demo",
			"link": "https://hadi-crm-sales.vercel.app",
			"image": "../hadi_crm_sales.png",
			"category": "Web",
			"tags": ["React", "Vite", "TailwindCSS", "Node.js"]
		},
		{
			"title": "Real Estate Platform",
			"description": "Modern real estate web platform to browse, search, and manage property listings. Features animated homepage, personalized property recommendations, and an agent dashboard for managing listings.",
			"logo": "../react1.png",
			"linkText": "Live Demo",
			"link": "https://real-state-beta-one.vercel.app",
			"image": "../realstate.png",
			"category": "Web",
			"tags": ["React", "Vite", "TailwindCSS", "Vercel"]
		},
		{
			"title": "Crypto Wallet App",
			"description": "Secure crypto-holding wallet app with transaction history, token sending, biometric authentication, and real-time balance tracking. Built with React Native frontend and Node.js backend with Web3 integration.",
			"logo": ["../reactnative.png", "../mern.png"],
			"linkText": "Watch Demo",
			"link": "https://www.youtube.com/watch?v=X8eSPQr8mjg&ab_channel=Hadi",
			"image": "../crypto_wallet_app.png",
			"category": "Mobile",
			"tags": ["React Native", "Node.js", "Web3", "Biometrics"]
		},
		{
			"title": "Nfuze Funding App",
			"description": "Investment funding platform connecting startups with investors. Led full frontend and backend development. Features campaign creation, investor dashboard, KYC verification, and secure payment flows.",
			"logo": "../flutter.png",
			"linkText": "View on TestFlight",
			"link": "https://testflight.apple.com/join/Bhpf2bCk",
			"image": "../nfuze_app.png",
			"category": "Mobile",
			"tags": ["Flutter", "Node.js", "MongoDB", "Payments"]
		},
		{
			"title": "Join Market App",
			"description": "Marketplace mobile app built with Flutter. Features product listings, vendor management, in-app chat, and order tracking. Deployed on iOS TestFlight for beta testing.",
			"logo": "../flutter.png",
			"linkText": "View on TestFlight",
			"link": "https://testflight.apple.com/join/eyQEbrSC",
			"image": "../join-marketapp.png",
			"category": "Mobile",
			"tags": ["Flutter", "Firebase", "iOS"]
		},
		{
			"title": "Custodiy – Web3 Platform",
			"description": "Contributed to a Web3 custody platform integrating blockchain wallet management, token transfers, and smart contract interactions. Built with React.js frontend, Node.js backend, Web3.js, and MongoDB.",
			"logo": ["../react1.png", "../mern.png"],
			"linkText": "View Site",
			"link": "https://web.custodiy.com",
			"image": "../custodiy_site.png",
			"category": "Web",
			"tags": ["React", "Node.js", "Web3", "MongoDB"]
		},
		{
			"title": "Peet's Coffee",
			"description": "Contributed to Peet's Coffee web platform. Implemented personalized coffee quiz feature, product recommendation engine, and optimized checkout flow for improved conversion rates.",
			"logo": "../mern.png",
			"linkText": "Visit Site",
			"link": "https://www.peets.com/",
			"image": "../peets.png",
			"category": "Web",
			"tags": ["React", "Node.js", "API"]
		},
		{
			"title": "Crown Affair",
			"description": "Contributed to Crown Affair's e-commerce platform. Implemented product subscription flows, custom bundle builder, and performance optimizations resulting in faster page load times.",
			"logo": "../mern.png",
			"linkText": "Visit Site",
			"link": "https://www.crownaffair.com/",
			"image": "../crownaffair.png",
			"category": "Web",
			"tags": ["React", "Node.js", "E-commerce"]
		},
		{
			"title": "Morphe – Beauty Platform",
			"description": "Contributed to Morphe's beauty e-commerce platform. Built product filtering system, shade finder tool, and influencer collaboration pages. Optimized for high-traffic flash sale events.",
			"logo": "../mern.png",
			"linkText": "Visit Site",
			"link": "https://www.morphe.com/",
			"image": "../morphe.png",
			"category": "Web",
			"tags": ["React", "Node.js", "E-commerce"]
		},
		{
			"title": "Freebie Frenzy",
			"description": "Converted Figma designs into a pixel-perfect responsive React.js landing page. Implemented smooth scroll animations, email capture form with validation, and optimized for Core Web Vitals.",
			"logo": "../react1.png",
			"linkText": "View Site",
			"link": "https://www.freebiefrenzy.io/",
			"image": "../freebie_frenzy.png",
			"category": "Web",
			"tags": ["React", "Figma", "CSS", "Animations"]
		},
		{
			"title": "Migration Check",
			"description": "Converted Figma designs into a fully functional React.js application for UAE visa and migration services. Features multi-step eligibility checker, document checklist, and consultation booking system.",
			"logo": "../react1.png",
			"linkText": "View Site",
			"link": "https://migration-check.com/",
			"image": "../migration_check.png",
			"category": "Web",
			"tags": ["React", "Figma", "UAE"]
		},
		{
			"title": "Join Market – Restaurant System",
			"description": "Full-stack restaurant ordering system with digital menu, table management, kitchen display system, and online payment integration. Reduced order processing time by 40%.",
			"logo": "../mern.png",
			"linkText": "View Site",
			"link": "http://54.156.172.162/",
			"image": "../restaurant_ordering_system.png",
			"category": "Web",
			"tags": ["MERN", "Node.js", "MongoDB", "Payments"]
		},
	]
	
};

export default INFO;
